<template>
  <div aria-hidden="true" class="onboarding-modal modal fade animated" id="invitationModal" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-centered" role="document">
      <div class="modal-content text-center">
        <button aria-label="Close" class="close" data-dismiss="modal" type="button"><span class="close-label">Skip Invite</span><span class="os-icon os-icon-close"></span></button>
        <div class="onboarding-media">
          <img alt="" src="img/bigicon5.png" width="200px">
        </div>
        <div class="onboarding-content with-gradient">
          <h4 class="onboarding-title">
            Lobby Invitation | {{ this.lobby.id }}
          </h4>
          <div class="onboarding-text">
            You've been invited by {{ this.lobby.host.username }} to their lobby.
          </div>
          <form>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <center><a class="btn btn-primary" @click="acceptInvite()" role="button">Join Lobby</a></center>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Invitation',
  data () {
    return {
      lobby: {
        id: 'null',
        host: {
          id: 'STEAM',
          name: 'STEAM'
        }
      }
    }
  },
  methods: {
    acceptInvite() {
      this.axios.post(`${this.API_URL}/kraken/lobbies/${this.lobby.id}/add`, { player: this.$root.userProfile }).then((res) => {
        this.$root.krakenLobby = res.data;
        $('#invitationModal').modal('hide');
      });
    },
    lobbyInvitation(lobby) {
      if (this.$root.krakenLobby.id != lobby.id) {
        this.lobby = lobby;
        $('#invitationModal').modal('show');
      }
    }
  },
  created() {
    this.$root.socket.on('message', (msg) => {
      if (msg.t === 'lobby_invitation') {
        this.lobbyInvitation(msg.d);
      }
    });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
